var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCadeado = function SvgCadeado(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.503 0c-7.924.01-14.345 6.43-14.355 14.354v8.834c0 .61.495 1.104 1.105 1.104h4.416c.61 0 1.104-.495 1.104-1.105v-8.833a7.73 7.73 0 1 1 15.459 0v8.834c0 .61.494 1.104 1.104 1.104h4.417c.61 0 1.104-.495 1.104-1.105v-8.833C40.847 6.431 34.427.01 26.503 0Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.247 22.083h26.5a5.52 5.52 0 0 1 5.521 5.52V47.48a5.52 5.52 0 0 1-5.52 5.52h-26.5a5.52 5.52 0 0 1-5.521-5.52V27.604a5.52 5.52 0 0 1 5.52-5.521Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.018 34.229a5.521 5.521 0 1 0-7.97 4.924l-.852 5.963a1.104 1.104 0 0 0 1.093 1.258h4.417a1.104 1.104 0 0 0 1.104-1.26l-.853-5.963a5.54 5.54 0 0 0 3.061-4.922Z",
    fill: "#455A64"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCadeado);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cadeado.ba480ffd0e62714fd1049c84123ded43.svg";